export { default } from './VehicleTile';
